import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import './styles/root.css';


ReactDOM.render(

    <Routes />
,
  document.getElementById('root')
)
